import React, { useEffect, useRef, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import '../../../assets/images/codestyle.css';
import useScrollSpy from 'react-use-scrollspy';
import ScrollToTop from '../../Shared/ScrollToTop';
import { ProjectTypeContext } from '../../../ContextHandle'
const GoogleFirebaseSetup = ({ setActivePage, sectionRefs, setDocumentation, setDefaultAppActiveMenu }) => {
     /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(504);
        setDocumentation(2);
        setDefaultAppActiveMenu(2);
        document.title = 'Google Firebase Setup | ' + projectName;
    }, [setActivePage, setDocumentation, setDefaultAppActiveMenu, projectName]);


    const pagesectionRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    const activeSection = useScrollSpy({
        sectionElementRefs: pagesectionRefs,
        offsetPx: -80,
    });


    return (
        <div className='d-flex   justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div id="system-requirements  " className='pt-5 right-content-box-width' >
                <nav  >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">Common Setup</li>
                        <li className="breadcrumb-item active" aria-current="page">Google Firebase Setup</li>
                    </ol>
                </nav>

                <h3 className="pt-5 font-weight-bold" ref={pagesectionRefs[1]}>Google Firebase Setup</h3>
                <p><b>Video tutorial</b></p>
                <iframe width="850" height="478" src="https://www.youtube.com/embed/Ol_21z4vpTE" title="WeCourier - Create a Firebase project | WemaxDevs" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                <h4 className='mt-2 font-weight-bold' id='follow' >Or follow the steps below:</h4>
                <ul  >
                    <li>Go to Firebase Console and login with your Google account.</li>
                    <li>Click on <b>Create a project</b> or <b>Add Project</b></li>
                    <li>Enter your project name and follow the Firebase steps to complete project creation.</li>
                    <li>After completing project creation, click <b>Continue</b> to open the project dashboard.</li>
                </ul>
                <h4 className='mt-2 font-weight-bold' id='android' >Android</h4>
                <ul ref={pagesectionRefs[2]}>
                    <li>Click the <b>Android</b> icon, enter the <b>Android package name</b> and <b>App nickname</b>, then click <b>Register app</b>.</li>
                    <li>Download the <b>google-services.json</b> file and copy it to the app source folder: <b>project » android » app</b>.</li>
                    <li>Repeat this step separately for the Merchant app and the Delivery app if both apps use push notifications.</li>
                </ul>
                <div className='alert alert-info'>
                    <i className='fa fa-circle-info '></i><span className='font-weight-bold'> INFO</span>
                    <p>The Android package name in Firebase must match your app package name, otherwise Firebase services will not work correctly.</p>
                </div>

                <h4 className='mt-2 font-weight-bold' id='ios'>iOS</h4>
                <ul ref={pagesectionRefs[3]}>
                    <li>Click the <b>iOS</b> icon, enter the <b>iOS bundle ID</b> and <b>App nickname</b>, then click <b>Register app</b>.</li>
                    <li>Download the <b>GoogleService-Info.plist</b> file and copy it to the app source folder: <b>project » ios » Runner</b>.</li>
                    <li>Repeat this step separately for the Merchant app and the Delivery app if both apps support iOS.</li>
                </ul>
                <div className='alert alert-info'>
                    <i className='fa fa-circle-info '></i><span className='font-weight-bold'> INFO</span>
                    <p>The iOS Bundle ID in Firebase must match your Xcode project Bundle Identifier, otherwise Firebase services will not work correctly.</p>
                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/app/prepare-flutter-environment`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Prepare Flutter Environment</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/app/push-notification-setup`} className="text-decoration-none">
                            <a href="/#" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Push Notification Setup</h4>
                        </NavLink>
                    </div>
                </div>
            </div>
            <div className='right-menu'>
                <ul >
                    <li><a href='#follow' className={activeSection == 1 ? 'active-has' : ""}>Follow the steps</a></li>
                    <li><a href='#android' className={activeSection == 2 ? 'active-has' : ""}>Android</a></li>
                    <li><a href='#ios' className={activeSection == 3 ? 'active-has' : ""}>IOS</a></li>
                </ul>
            </div>

        </div>

    );

};

export default GoogleFirebaseSetup;
